import ReactGA from 'react-ga'

const ensureNumber = value => {
  const type = typeof value
  if (type === 'string') return parseFloat(value)
  if (type === 'number') return value
  return undefined
}

const ecAddProduct = ({
  id,
  name,
  category,
  brand,
  variant,
  price,
  quantity
}) => {
  ReactGA.plugin.execute('ec', 'addProduct', {
    id,
    name,
    category,
    brand,
    variant,
    price: ensureNumber(price),
    quantity: ensureNumber(quantity)
  })
}

export const trackAddProduct = product => {
  ecAddProduct(product)
  ReactGA.plugin.execute('ec', 'setAction', 'add')
}

export const trackRemoveProduct = product => {
  ecAddProduct(product)
  ReactGA.plugin.execute('ec', 'setAction', 'remove')
}

export const trackPurchase = (products, { id, diningOptionBehavior, revenue, tax, shipping, option, tip }) => {
  const data = {
    id,
    diningOptionBehavior,
    revenue: ensureNumber(revenue),
    tax: ensureNumber(tax),
    shipping: ensureNumber(shipping),
    option,
    tip: ensureNumber(tip)
  }
  products.forEach(product => ecAddProduct(product))
  ReactGA.plugin.execute('ec', 'setAction', 'purchase', data)
}
